<template>
  <div class="voucher-table bg-white-color">
    <table class="header" cellspacing="0" cellpadding="0">
      <tbody>
      <tr class="bg-white-color">
        <td style="width: 208px; font-weight: bold;">摘要</td>
        <td style="width: 308px; font-weight: bold;">会计科目</td>
        <td>
          <div style="font-weight: bold;">
            借方金额
          </div>
          <div class="moneyUint">
            <span>亿</span> <span>千</span> <span>百</span> <span>十</span> <span>万</span> <span>千</span>
            <span>百</span> <span>十</span> <span>元</span> <span>角</span> <span class="last">分</span>
          </div>
        </td>
        <td class="tdLast">
          <div style="font-weight: bold;">
            贷方金额
          </div>
          <div class="moneyUint">
            <span>亿</span> <span>千</span> <span>百</span> <span>十</span> <span>万</span> <span>千</span>
            <span>百</span> <span>十</span> <span>元</span> <span>角</span> <span class="last">分</span>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
    <table class="body" cellspacing="0" cellpadding="0">
      <tbody>
      <tr class="trDetails" v-for="(d,i) in details" :key="i" :data-idx="i">
        <td class="tdZhaoyao tdInput">
          <div class="display" v-if="!d.zyEdit" @click="doEdit(d,'zy',i, i)">{{d.data.summary}}</div>
          <DropdownCustom v-show="d.zyEdit" ref="zyDropdown" trigger="manual" :toggle-icon="false" style="width: 100%" equalWidth @hide="endEdit(d,'zy',i)">
            <textarea class="h-input edit" data-type="zy" :data-index="i" :id="'zy'+i" @input="zyInput"></textarea>
            <template slot="content">
              <div style="height: 180px;overflow-y: scroll;">
                <ul class="summary" :id="`summary${i}`">
                  <li class="summary-item" :data-index="idx" :class="{'summary-item-select':(idx===0&&zyFiler)}" v-for="(s,idx) in summaryData" @click="chooseSummary(d,s.name,i)">
                    {{s.name}}
                  </li>
                </ul>
              </div>
            </template>
          </DropdownCustom>
        </td>
        <td class="tdKemu tdInput">
          <div class="display" v-if="!d.kmEdit" @click="doEdit(d,'km',i)">
            {{d.data.subjectName||''}}{{d.data.auxiliaryTitle||''}}
          </div>
          <div class="yue" v-if="balanceList[d.data.subjectId]">余额：
            <span :class="{'red-color':balanceList[d.data.subjectId]<0}">{{balanceList[d.data.subjectId] | numFormat}}</span>
          </div>
          <Row v-if="d.data.unit || d.data.num" @click.stop="" class="num" type="flex" :space-x="10">
            <Cell>数量:</Cell>
            <Cell>
              <span @click.stop="showInput" class="text-hover">{{d.data.num||0}}</span>
              <input class="numInput" @blur.stop="hideInput($event,d.data)" @click="" style="display: none;" v-model="d.data.num" @click.stop="" v-width="40">
            </Cell>
            <Cell>单价:</Cell>
            <Cell>
              <span @click.stop="showInput" class="text-hover">{{d.data.price||0}}</span>
              <input class="numInput" @blur.stop="hideInput($event,d.data)" style="display: none;" v-model="d.data.price" @click.stop="" v-width="40">
            </Cell>
          </Row>
          <DropdownCustom v-show="d.kmEdit" ref="kmDropdown" trigger="manual" :toggle-icon="false" style="width: 100%" equalWidth @hide="endEdit(d,'km',i)">
            <textarea class="h-input edit" data-type="km" :data-index="i" :id="'km'+i" @input="kmInput"></textarea>
            <template slot="content">

              <!-- 科目选择显示区域 -->
              <div style="height: 180px;overflow-y: scroll;" v-if="!d.auxiliary">
                <ul class="subjects" :id="`subjects${i}`">
                  <li class="subjects-item" :data-index="idx" :class="{'subjects-item-select':(idx===0&&kmFiler)}" v-for="(s,idx) in subjectData" @click="chooseSubject(d,s,i)">
                    {{s.code}} {{s.name}}
                  </li>
                </ul>
              </div>
              <!-- 辅助核算项显示区域 -->
              <div v-else class="auxiliary padding">
                <div class="text-center margin-top">
                  <Button v-if="auxiliaryAccounting[i]" color="primary" @click="openAuxiliaryModal(i, d)">编辑辅助核算</Button>
                </div>
                <!-- 新增辅助核算项目按钮 -->
                <div class="text-center margin-top">
                  <Button color="primary" @click="openAddAuxiliaryModal(i)">新增辅助</Button>
                  <Button color="primary" @click="openAssetForm">新增资产</Button>
                </div>
              </div>
              <!-- 显示部门往来的显示区域 -->
<!--              <Modal v-model="showAuxiliaryModal"  hasCloseIcon  @keydown.enter.native="confirmAuxiliary" @keydown.esc.native="showAuxiliaryModal = false">-->
              <Modal v-model="showAuxiliaryModal" :close-on-mask="false" @keydown.enter.native="confirmAuxiliary">
              <!--显示科目信息，科目代码+名称-->
                <div slot="header" class="h-panel-bar">
                  <span class="h-panel-title">{{ auxiliaryModalTitle }}</span>
                </div>
                <!-- 选择部门往来区域 -->
                <div class="auxiliary padding" v-if="currentAuxiliaryIndex >= 0">
                  <Row v-for="(item, rowIndex) in auxiliaryAccounting[currentAuxiliaryIndex]" type="flex" :space="30" :key="item.id">
                    <Cell :flex="1" class="label">{{ item.name }}</Cell>
                    <Cell v-width="440">
                      <DropdownCustom
                          ref="auxDropdown"
                          trigger="manual"
                          :toggle-icon="false"
                          style="width: 100%"
                          equalWidth
                          @hide="onAuxDropdownHide(rowIndex)"
                      >
                        <input
                            class="h-input edit auxiliary-input"
                            :data-row-index="rowIndex"
                            :id="'auxInput' + rowIndex"
                            v-model="auxiliaryFilters[item.id]"
                            @input="onAuxiliaryInput($event, item.id, rowIndex)"
                            @keydown="onAuxiliaryKeydown($event, item.id, rowIndex)"
                            @focus="onAuxiliaryFocus(item.id, rowIndex)"
                            @click="onAuxiliaryClick(item.id, rowIndex)"
                            :placeholder="getAuxiliaryDisplayValue(item.id) || '请输入代码'"
                        >
                        <template slot="content">
                          <div style="height: 180px;overflow-y: scroll;" v-if="auxiliaryAccountingData[currentAuxiliaryData.data.subjectId] && auxiliaryAccountingData[currentAuxiliaryData.data.subjectId][item.id]">
                            <ul class="subjects" :id="'auxList' + rowIndex">
                              <li
                                  class="subjects-item"
                                  :data-index="idx"
                                  :class="{'subjects-item-select':(idx===0 && getAuxiliaryFilter(item.id))}"
                                  v-for="(s,idx) in getFilteredAuxiliaryList(item.id)"
                                  @click="chooseAuxiliaryItem(s, item.id, rowIndex)"
                              >
                                {{s.code}} {{s.name}}
                              </li>
                            </ul>
                          </div>
                        </template>
                      </DropdownCustom>
                    </Cell>
                  </Row>
                </div>
                <!-- 确定部门往来区域 -->
                <div class="text-center margin-top">
                  <Button color="primary" @click="confirmAuxiliary">确认</Button>
                  <Button @click="showAuxiliaryModal = false">取消</Button>
                </div>
              </Modal>

              <!-- 新增辅助核算项目模态框 -->
              <Modal v-model="showAddAuxiliaryModal" type="drawer-right" hasCloseIcon>
                <div slot="header" class="h-panel-bar">
                  <span class="h-panel-title">新增辅助核算</span>
                </div>
                <Form v-width="400" :labelWidth="100" :model="newAuxiliaryForm">
                  <FormItem label="核算类别:">
                    <input type="text" v-model="currentAuxiliaryCategory.name" disabled>
                  </FormItem>
                  <FormItem label="编码:" prop="code">
                    <input type="text" v-model="newAuxiliaryForm.code" placeholder="请输入编码">
                  </FormItem>
                  <FormItem label="名称:" prop="name">
                    <input type="text" v-model="newAuxiliaryForm.name" placeholder="请输入名称">
                  </FormItem>
                  <FormItem label="备注:" prop="remark">
                    <textarea v-model="newAuxiliaryForm.remark" rows="3" placeholder="请输入备注"></textarea>
                  </FormItem>
                </Form>
                <div class="text-center">
                  <Button color="primary" @click="addAuxiliaryItem">保存</Button>
                  <Button @click="showAddAuxiliaryModal = false">取消</Button>
                </div>
              </Modal>
              <!--固定资产区域 -->
              <AssetFormModal
                  v-model="showAssetFormModal"
                  :asset-data="currentAssetData"
                  @success="onAssetSaveSuccess"
                  @close="showAssetFormModal = false"
              />
            </template>
          </DropdownCustom>

<!--          <DropdownCustom v-show="d.kmEdit" ref="kmDropdown" trigger="manual" :toggle-icon="false" style="width: 100%" equalWidth @hide="endEdit(d,'km',i)">-->
<!--            <textarea class="h-input edit" data-type="km" :data-index="i" :id="'km'+i" @input="kmInput"></textarea>-->
<!--            <template slot="content">-->

<!--              &lt;!&ndash; 科目选择显示区域 &ndash;&gt;-->
<!--              <div style="height: 180px;overflow-y: scroll;" v-if="!d.auxiliary">-->
<!--                <ul class="subjects" :id="`subjects${i}`">-->
<!--                  <li class="subjects-item" :data-index="idx" :class="{'subjects-item-select':(idx===0&&kmFiler)}" v-for="(s,idx) in subjectData" @click="chooseSubject(d,s,i)">-->
<!--                    {{s.code}} {{s.name}}-->
<!--                  </li>-->
<!--                </ul>-->
<!--              </div>-->
<!--              &lt;!&ndash; 辅助核算项显示区域 &ndash;&gt;-->
<!--              <div v-else class="auxiliary padding">-->
<!--                <div class="text-center margin-top">-->
<!--                  <Button v-if="auxiliaryAccounting[i]" color="primary" @click="openAuxiliaryModal(i, d)">编辑辅助核算</Button>-->
<!--                </div>-->
<!--                &lt;!&ndash; 新增辅助核算项目按钮 &ndash;&gt;-->
<!--                <div class="text-center margin-top">-->
<!--                  <Button color="primary" @click="openAddAuxiliaryModal(i)">新增辅助</Button>-->
<!--                  <Button color="primary" @click="openAssetForm">新增资产</Button>-->
<!--                </div>-->
<!--              </div>-->
<!--            </template>-->
<!--          </DropdownCustom>-->
<!--              &lt;!&ndash; 显示部门往来的显示区域 &ndash;&gt;-->
<!--              <Modal v-model="showAuxiliaryModal" :maskClosable="false" @click.native.stop @keydown.enter.native="confirmAuxiliary">-->
<!--                &lt;!&ndash;显示科目信息，科目代码+名称&ndash;&gt;-->
<!--                <div slot="header" class="h-panel-bar">-->
<!--                  <span class="h-panel-title">{{ auxiliaryModalTitle }}</span>-->
<!--                </div>-->
<!--                &lt;!&ndash; 选择部门往来区域 &ndash;&gt;-->
<!--                <div class="auxiliary padding" v-if="currentAuxiliaryIndex >= 0">-->
<!--                  <Row v-for="(item, rowIndex) in auxiliaryAccounting[currentAuxiliaryIndex]" type="flex" :space="30" :key="item.id">-->
<!--                    <Cell :flex="1" class="label">{{ item.name }}</Cell>-->
<!--                    <Cell v-width="440">-->
<!--                      <DropdownCustom-->
<!--                          ref="auxDropdown"-->
<!--                          trigger="manual"-->
<!--                          :toggle-icon="false"-->
<!--                          style="width: 100%"-->
<!--                          equalWidth-->
<!--                          @hide="onAuxDropdownHide(rowIndex)"-->
<!--                      >-->
<!--                        <input-->
<!--                            class="h-input edit auxiliary-input"-->
<!--                            :data-row-index="rowIndex"-->
<!--                            :id="'auxInput' + rowIndex"-->
<!--                            v-model="auxiliaryFilters[item.id]"-->
<!--                            @input="onAuxiliaryInput($event, item.id, rowIndex)"-->
<!--                            @keydown="onAuxiliaryKeydown($event, item.id, rowIndex)"-->
<!--                            @focus="onAuxiliaryFocus(item.id, rowIndex)"-->
<!--                            @click="onAuxiliaryClick(item.id, rowIndex)"-->
<!--                            :placeholder="getAuxiliaryDisplayValue(item.id) || '请输入代码'"-->
<!--                        >-->
<!--                        <template slot="content">-->
<!--                          <div style="height: 180px;overflow-y: scroll;" v-if="auxiliaryAccountingData[currentAuxiliaryData.data.subjectId] && auxiliaryAccountingData[currentAuxiliaryData.data.subjectId][item.id]">-->
<!--                            <ul class="subjects" :id="'auxList' + rowIndex">-->
<!--                              <li-->
<!--                                  class="subjects-item"-->
<!--                                  :data-index="idx"-->
<!--                                  :class="{'subjects-item-select':(idx===0 && getAuxiliaryFilter(item.id))}"-->
<!--                                  v-for="(s,idx) in getFilteredAuxiliaryList(item.id)"-->
<!--                                  @click="chooseAuxiliaryItem(s, item.id, rowIndex)"-->
<!--                              >-->
<!--                                {{s.code}} {{s.name}}-->
<!--                              </li>-->
<!--                            </ul>-->
<!--                          </div>-->
<!--                        </template>-->
<!--                      </DropdownCustom>-->
<!--                    </Cell>-->
<!--                  </Row>-->
<!--                </div>-->
<!--                &lt;!&ndash; 确定部门往来区域 &ndash;&gt;-->
<!--                <div class="text-center margin-top">-->
<!--                  <Button color="primary" @click="confirmAuxiliary">确认</Button>-->
<!--                  <Button @click="showAuxiliaryModal = false">取消</Button>-->
<!--                </div>-->
<!--              </Modal>-->

<!--              &lt;!&ndash; 新增辅助核算项目模态框 &ndash;&gt;-->
<!--              <Modal v-model="showAddAuxiliaryModal" type="drawer-right" hasCloseIcon>-->
<!--                <div slot="header" class="h-panel-bar">-->
<!--                  <span class="h-panel-title">新增辅助核算</span>-->
<!--                </div>-->
<!--                <Form v-width="400" :labelWidth="100" :model="newAuxiliaryForm">-->
<!--                  <FormItem label="核算类别:">-->
<!--                    <input type="text" v-model="currentAuxiliaryCategory.name" disabled>-->
<!--                  </FormItem>-->
<!--                  <FormItem label="编码:" prop="code">-->
<!--                    <input type="text" v-model="newAuxiliaryForm.code" placeholder="请输入编码">-->
<!--                  </FormItem>-->
<!--                  <FormItem label="名称:" prop="name">-->
<!--                    <input type="text" v-model="newAuxiliaryForm.name" placeholder="请输入名称">-->
<!--                  </FormItem>-->
<!--                  <FormItem label="备注:" prop="remark">-->
<!--                    <textarea v-model="newAuxiliaryForm.remark" rows="3" placeholder="请输入备注"></textarea>-->
<!--                  </FormItem>-->
<!--                </Form>-->
<!--                <div class="text-center">-->
<!--                  <Button color="primary" @click="addAuxiliaryItem">保存</Button>-->
<!--                  <Button @click="showAddAuxiliaryModal = false">取消</Button>-->
<!--                </div>-->
<!--              </Modal>-->
<!--              &lt;!&ndash;固定资产区域 &ndash;&gt;-->
<!--              <AssetFormModal-->
<!--                  v-model="showAssetFormModal"-->
<!--                  :asset-data="currentAssetData"-->
<!--                  @success="onAssetSaveSuccess"-->
<!--                  @close="showAssetFormModal = false"-->
<!--              />-->
        </td>
        <!--
        记账凭证借方金额编辑单元格组件
        功能：根据编辑状态显示不同的输入方式，支持点击编辑和下拉数字输入
        -->
        <td class="tdJieFang tdInput">
          <!-- 非编辑状态下显示借方金额，支持点击进入编辑模式 -->
          <div v-if="!d.jfEdit" class="display displayMoney" :class="{'red-color':d.data.debitAmount<0}" @click="doEdit(d,'jf',i)">
            <span @click.stop="doEdit(d,'jf',i)">{{d.data.debitAmount|formatMoney}}</span>
          </div>
          <!-- 编辑状态下显示自定义下拉输入框，包含数字输入和格式化显示 -->
          <DropdownCustom v-show="d.jfEdit" ref="jfDropdown" placement="top" trigger="manual" :toggle-icon="false" style="width: 100%" equalWidth @hide="endEdit(d,'jf',i)">
            <input max="999999999" min="-999999999" type="number" class="h-input jf edit" data-type="jf" :data-index="i" :id="'jf'+i" v-model="d.data.debitAmount">
            <template slot="content">
              <div class="hoverNum">{{d.data.debitAmount|numFormat}}</div>
            </template>
          </DropdownCustom>
        </td>
        <!--   贷方金额     -->
        <td class="tdLast tdDaiFang tdInput">
          <div v-if="!d.dfEdit" class="display displayMoney" :class="{'red-color':d.data.creditAmount<0}" @click="doEdit(d,'df',i)">
            <span @click.stop="doEdit(d,'df',i)">{{d.data.creditAmount|formatMoney}}</span>
          </div>
          <DropdownCustom v-show="d.dfEdit" ref="dfDropdown" placement="top" trigger="manual" :toggle-icon="false" style="width: 100%" equalWidth @hide="endEdit(d,'df',i)">
            <input max="999999999" min="-999999999" :data-index="i" data-type="df" class="h-input df edit" :id="'df'+i" v-model="d.data.creditAmount" step="" placeholder="输入=号自动计算">
            <template slot="content">
              <div class="hoverNum">{{d.data.creditAmount|numFormat}}</div>
            </template>
          </DropdownCustom>
        </td>
      </tr>
      <tr class="trDetails total">
        <td colspan="2" class="spTotal padding-left">
          合计: {{jfTotal < 0 ? -jfTotal : jfTotal | dxMoney}}
          <!--          合计: {{jfTotal|dxMoney}}-->
        </td>
        <!-- 显示借方合计金额 -->
        <td style="width: 220px;">
          <div class="display displayMoney" :class="{'red-color':jfTotal<0}">
            <span class="spTotalDebit">{{jfTotal|formatMoney}}</span>
          </div>
        </td>
        <!-- 显示贷方合计金额 -->
        <td class="tdLast" style="width: 220px;">
          <div class="display displayMoney" :class="{'red-color':dfTotal<0}">
            <span class="spTotalCredit">{{dfTotal|formatMoney}}</span>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
    <i class="action fa fa-times-circle" @click="removeItem()"></i>
    <i class="action fa fa-plus-circle" @click="addItem()"></i>
  </div>
</template>

<script>
import jQuery from 'jquery';
import Decimal from 'decimal.js';
import Pinyin from 'chinese-to-pinyin';
import AssetFormModal from '@/views/asset/AssetFormModal.vue'
const detail = {
  zyEdit: false,
  kmEdit: false,
  jfEdit: false,
  dfEdit: false,
  auxiliary: false,
  data: {summary: '', subjectName: ''}
};

const nextTag = {
  zy: 'km',
  km: 'jf',
  jf: 'df'
};

const FormatNum = function (num, digit = 2) {
  return Decimal(num).toFixed(digit);
};

const ToPy = (name) => {
  let pyArr = [];
  name.split("").forEach(w => {
    w = w.trim();
    if (w) {
      if (/[\u4e00-\u9fa5]/.test(w)) {
        let py = Pinyin(w, {removeTone: true, keepRest: true}).trim();
        pyArr.push(py.substring(0, 1));
      } else {
        pyArr.push(w);
      }
    }
  });

  return pyArr.join("");
};
/**凭证表格组件 */
export default {
  name: "VoucherTable",
  components: {AssetFormModal},
  props: {
    value: Object,
  },
  data() {
    return {
      details: [{zyEdit: false, kmEdit: false, jfEdit: false, dfEdit: false, auxiliary: false, data: {summary: ''}}, {zyEdit: false, kmEdit: false, jfEdit: false, dfEdit: false, auxiliary: false, data: {summary: ''}}, {zyEdit: false, kmEdit: false, jfEdit: false, dfEdit: false, auxiliary: false, data: {summary: ''}}, {zyEdit: false, kmEdit: false, jfEdit: false, dfEdit: false, auxiliary: false, data: {summary: ''}}],
      hoverIdx: -1,
      voucherSelect: [],
      summarySelect: [],
      auxiliaryAccounting: [],
      zyFiler: "",
      kmFiler: "",
      zaiYao: [],
      balanceList: {},
      initBalanceList: {},
      auxiliaryAccountingData: {},
      currentEdit: null,
      jfTotal: 0,
      dfTotal: 0,
      showAddAuxiliaryModal: false,
      newAuxiliaryForm: {
        code: '',
        name: '',
        remark: ''
      },
      /**
       * 当前正在编辑的辅助核算数据所在行的索引
       * 用于标识用户正在操作的凭证分录位置，在打开辅助核算模态框时设置
       * @type {number} 索引值，初始值为 -1 表示未选择任何行
       */
      currentAuxiliaryIndex: -1,
      /**
       * 当前选中的辅助核算类别信息对象
       * 存储从父组件传递或 API 获取的辅助核算类别详细数据
       * 包含类别的名称、编码等信息，用于新增辅助核算项目时使用
       * @type {Object} 辅助核算类别对象，初始为空对象
       */// 当前正在编辑的行索引
      currentAuxiliaryCategory: {}, // 当前辅助核算类别
      showAssetFormModal: false,
      /**
       * 当前正在编辑的固定资产数据对象
       * 用于在编辑现有固定资产时传递数据到表单模态框
       * null 表示新增模式，有值表示编辑模式
       * @type {Object|null} 固定资产数据对象，初始为 null
       */
      currentAssetData: null,
      /**
       * 控制辅助核算设置模态框的显示与隐藏
       * true 表示显示模态框，false 表示隐藏模态框
       * @type {boolean} 模态框状态标识，初始为 false
       */
      showAuxiliaryModal: false,
      /**
       * 临时存储当前正在编辑的辅助核算数据副本
       * 用于在模态框中编辑时保存用户修改的数据，避免直接修改原始数据
       * 通过深拷贝方式创建独立对象，防止数据污染
       * @type {Object|null} 包含辅助核算项目选择信息的对象，初始值为 null
       */
      currentAuxiliaryData: null,

      modalKeyDownHandler: null,

      auxiliaryFilters: {},
      currentAuxDropdownIndex: -1,
    }
  },
  computed: {
    /**
     * 计算并返回过滤后的会计科目数据
     * 若存在搜索关键词，则根据关键词对会计科目数据进行过滤
     * 若不存在搜索关键词，则返回全部会计科目数据
     * @returns {Array} 过滤后的会计科目数据数组
     */
    subjectData() {
      // 检查是否存在会计科目搜索关键词
      if (this.kmFiler) {
        // 若存在搜索关键词，使用 filter 方法对 voucherSelect 数组进行过滤
        return this.voucherSelect.filter(value => {
          // 只要会计科目的编码、名称或助记码中包含搜索关键词，就保留该元素
          return value.code.indexOf(this.kmFiler) !== -1 || value.name.indexOf(this.kmFiler) !== -1 || value.mnemonicCode.indexOf(this.kmFiler) !== -1;
        });
      }
      // 若不存在搜索关键词，直接返回全部会计科目数据
      return this.voucherSelect;
    },

    /**
     * 计算并返回过滤后的摘要数据列表
     * 若存在摘要搜索关键词，则根据关键词对摘要数据进行过滤
     * 若不存在搜索关键词，则返回全部摘要数据
     * @returns {Array} 过滤后的摘要数据数组
     */
    summaryData() {
      // 检查是否存在摘要搜索关键词
      if (this.zyFiler) {
        // 若存在搜索关键词，使用 filter 方法对 summarySelect 数组进行过滤
        return this.summarySelect.filter(value => {
          // 只要摘要的名称或助记码中包含搜索关键词，就保留该元素
          return value.name.indexOf(this.zyFiler) !== -1 || value.mnemonicCode.indexOf(this.zyFiler) !== -1;
        });
      }
      // 若不存在搜索关键词，直接返回全部摘要数据
      return this.summarySelect;
    },

    /**
     * 获取有效的凭证条目列表
     * 该方法会对组件中的凭证详情数据进行处理，过滤掉无效的条目，并对有效条目进行格式转换
     * @returns {Array} 包含有效凭证条目的数组
     */
    voucherItems() {
      // 首先将 details 数组中的每个元素的 data 属性提取出来
      // 然后过滤掉那些 subjectId、summary、debitAmount 和 creditAmount 都为空的无效条目
      return this.details.map(value => value.data).filter(value => {
        return value.subjectId || value.summary || value.debitAmount || value.creditAmount;
      }).map(value => {
        // 筛选出 value 对象中键为数字类型的属性名
        let keys = Object.keys(value).filter(key => !isNaN(Number(key))), auxiliary = [];
        // 如果存在键为数字类型的属性，则将这些属性的值添加到 auxiliary 数组中
        if (keys.length) {
          keys.forEach(key => {
            auxiliary.push(value[key]);
          })
        }

        // 返回处理后的凭证条目对象
        return {
          auxiliary, // 辅助核算信息数组
          debitAmount: value.debitAmount, // 借方金额
          creditAmount: value.creditAmount, // 贷方金额
          subjectId: value.subjectId, // 会计科目 ID
          direction: value.direction, // 余额方向
          subjectName: value.subjectName || '', // 会计科目名称
          subjectCode: value.subjectCode || '', // 会计科目编码
          auxiliaryTitle: value.auxiliaryTitle || '', // 辅助核算标题
          // 对摘要进行处理，去除首尾空格并将连续空格替换为单个空格
          summary: value.summary ? value.summary.trim().replace(/\s+/g, '') : '',
          num: value.num, // 数量
          price: value.price // 单价
        }
      });
    },


    /**
     * 辅助核算模态框标题
     * @returns {string} 格式化后的标题文本
     */
    auxiliaryModalTitle() {
      if (this.currentAuxiliaryData && this.currentAuxiliaryData.data) {
        const code = this.currentAuxiliaryData.data.subjectCode || '';
        const name = (this.currentAuxiliaryData.data.subject && this.currentAuxiliaryData.data.subject.name) || '';
        return `${code}-${name}`.trim();
      }
      return '';
    },
  },
  methods: {


    getAuxiliaryFilter(itemId) {
      return this.auxiliaryFilters[itemId] || '';
    },

    getFilteredAuxiliaryList(itemId) {
      const subjectId = this.currentAuxiliaryData.data.subjectId;
      if (!this.auxiliaryAccountingData[subjectId] || !this.auxiliaryAccountingData[subjectId][itemId]) {
        return [];
      }
      const dataList = this.auxiliaryAccountingData[subjectId][itemId];
      const filter = this.auxiliaryFilters[itemId];
      if (filter) {
        return dataList.filter(value => {
          return (value.code && value.code.indexOf(filter) !== -1) ||
              (value.name && value.name.indexOf(filter) !== -1) ||
              (value.codeAndName && value.codeAndName.indexOf(filter) !== -1);
        });
      }
      return dataList;
    },

    getAuxiliaryDisplayValue(itemId) {
      const selectedData = this.currentAuxiliaryData.data[itemId];
      if (selectedData && selectedData.code && selectedData.name) {
        return selectedData.code + '-' + selectedData.name;
      }
      return '';
    },

    onAuxiliaryInput(e, itemId, rowIndex) {
      this.$set(this.auxiliaryFilters, itemId, e.target.value);
      this.$nextTick(() => {
        if (this.$refs.auxDropdown && this.$refs.auxDropdown[rowIndex]) {
          this.$refs.auxDropdown[rowIndex].show();
        }
      });
    },

    onAuxiliaryFocus(itemId, rowIndex) {
      this.currentAuxDropdownIndex = rowIndex;
      this.$nextTick(() => {
        if (this.$refs.auxDropdown && this.$refs.auxDropdown[rowIndex]) {
          this.$refs.auxDropdown[rowIndex].show();
        }
      });
    },

    onAuxiliaryClick(itemId, rowIndex) {
      this.currentAuxDropdownIndex = rowIndex;
      const input = jQuery('#auxInput' + rowIndex);
      input.select();
      this.$nextTick(() => {
        if (this.$refs.auxDropdown && this.$refs.auxDropdown[rowIndex]) {
          this.$refs.auxDropdown[rowIndex].show();
        }
      });
    },

    onAuxDropdownHide(rowIndex) {
      const currentAuxiliaryItems = this.auxiliaryAccounting[this.currentAuxiliaryIndex] || [];
      if (rowIndex < currentAuxiliaryItems.length) {
        const itemId = currentAuxiliaryItems[rowIndex].id;
        // 只有在该项未选择时才清空筛选器，已选择的项应保持显示
        if (!this.currentAuxiliaryData.data[itemId]) {
          this.$set(this.auxiliaryFilters, itemId, '');
        }
      }
    },

    onAuxiliaryKeydown(e, itemId, rowIndex) {
      if (e.keyCode === 13 || e.keyCode === 9) {
        e.preventDefault();
        const filter = this.auxiliaryFilters[itemId];
        if (filter) {
          const selectItem = jQuery('li.subjects-item-select', '#auxList' + rowIndex);
          if (selectItem.length) {
            selectItem.click();
          }
        }
        return false;
      }

      if (e.keyCode === 38 || e.keyCode === 40) {
        e.preventDefault();
        const list = jQuery('#auxList' + rowIndex);
        let select = jQuery('.subjects-item-select', list);

        if (!select.length) {
          list.children().first().addClass('subjects-item-select');
          return false;
        }

        let next = select.prev('li');
        if (e.keyCode === 40) {
          next = select.next('li');
        }

        if (next.length) {
          next.addClass('subjects-item-select');
          select.removeClass('subjects-item-select');
          let i = next.data('index');
          if (i > 7) {
            let top = list.parent().scrollTop();
            list.parent().scrollTop(top + 22);
          }
        }
        return false;
      }
    },


    chooseAuxiliaryItem(item, itemId, rowIndex) {
      // 记录选择前该项是否有值
      const hadValueBefore = !!this.currentAuxiliaryData.data[itemId];

      this.$set(this.currentAuxiliaryData.data, itemId, item);
      this.$set(this.auxiliaryFilters, itemId, item.code + '-' + item.name);

      if (this.$refs.auxDropdown && this.$refs.auxDropdown[rowIndex]) {
        this.$refs.auxDropdown[rowIndex].hide();
      }

      // 只有在之前是空项的情况下（新增场景），才执行自动跳转或确认
      if (!hadValueBefore) {
        const currentAuxiliaryItems = this.auxiliaryAccounting[this.currentAuxiliaryIndex];
        const allSelected = currentAuxiliaryItems.every(auxItem =>
            this.currentAuxiliaryData.data[auxItem.id]
        );

        if (allSelected) {
          this.$nextTick(() => {
            this.confirmAuxiliary();
          });
        } else {
          this.$nextTick(() => {
            const nextIndex = rowIndex + 1;
            if (nextIndex < currentAuxiliaryItems.length) {
              const nextInput = jQuery('#auxInput' + nextIndex);
              nextInput.focus().select();
            }
          });
        }
      }
    },



    confirmAuxiliary() {
      // 将辅助核算数据复制回原数据对象
      if (this.currentAuxiliaryData && this.currentAuxiliaryIndex >= 0) {
        Object.assign(this.details[this.currentAuxiliaryIndex].data, this.currentAuxiliaryData.data);
      }
      this.showAuxiliaryModal = false;
      // 填充辅助核算信息
      this.fillAuxiliary(this.details[this.currentAuxiliaryIndex],
          this.auxiliaryAccountingData[this.currentAuxiliaryData.data.subjectId],
          this.currentAuxiliaryIndex);
    },
    /**
     * 打开辅助核算设置模态框并自动聚焦到第一个输入框
     * @param {number} index - 当前行的索引，用于标识需要设置的辅助核算数据位置
     * @param {Object} data - 当前的辅助核算数据对象，包含需要编辑的详细信息
     */

    openAuxiliaryModal(index, data) {
      this.currentAuxiliaryIndex = index;
      this.currentAuxiliaryData = JSON.parse(JSON.stringify(data));
      this.showAuxiliaryModal = true;

      this.auxiliaryFilters = {};
      const currentAuxiliaryItems = this.auxiliaryAccounting[index] || [];
      currentAuxiliaryItems.forEach(item => {
        const selectedValue = data.data[item.id];
        if (selectedValue && selectedValue.code) {
          this.$set(this.auxiliaryFilters, item.id, selectedValue.code + '-' + selectedValue.name);
        } else {
          this.$set(this.auxiliaryFilters, item.id, '');
        }
      });

      // 在模态框打开后将焦点设置到第一个未填写的输入框，如果没有未填写的则设置到第一个输入框
      this.$nextTick(() => {
        setTimeout(() => {
          let firstEmptyIndex = -1;
          for (let i = 0; i < currentAuxiliaryItems.length; i++) {
            const itemId = currentAuxiliaryItems[i].id;
            if (!this.currentAuxiliaryData.data[itemId]) {
              firstEmptyIndex = i;
              break;
            }
          }

          // 如果所有项都已填写，则聚焦到第一个输入框
          const targetIndex = firstEmptyIndex >= 0 ? firstEmptyIndex : 0;
          const targetInput = document.getElementById('auxInput' + targetIndex);

          if (targetInput) {
            targetInput.focus();
            targetInput.select();

            // 只有当该项为空时才自动展开下拉框
            if (firstEmptyIndex >= 0) {
              const inputEvent = new Event('input', { bubbles: true });
              targetInput.dispatchEvent(inputEvent);

              if (this.$refs.auxDropdown && this.$refs.auxDropdown[targetIndex]) {
                this.$refs.auxDropdown[targetIndex].show();
              }
            }
          }
        }, 300);
      });
    },


    /**
     * 打开固定资产新增界面
     */
    openAssetForm() {
      this.currentAssetData = null;
      this.showAssetFormModal = true;
    },

    /**
     * 固定资产保存成功回调
     */
    onAssetSaveSuccess(assetData) {
      // 处理固定资产保存成功后的逻辑
      this.$Message.success('固定资产保存成功');
      // 可以在这里添加其他业务逻辑
    },
    /**
     * 打开新增辅助核算项目模态框
     * @param {number} index - 当前行索引
     */
    openAddAuxiliaryModal(index) {
      // 获取当前行的辅助核算类别
      const categoryId = this.auxiliaryAccounting[index][0].id; // 取第一个辅助核算类别作为示例
      this.currentAuxiliaryCategory = this.auxiliaryAccounting[index].find(item => item.id === categoryId) || {};
      this.currentAuxiliaryIndex = index;
      // 根据类别名称自动生成编码前缀
      const prefix = this.getCategoryPrefix(this.currentAuxiliaryCategory.name);
      // 生成默认编码
      this.generateNextCode(prefix).then(code => {
        this.newAuxiliaryForm = {
          code: code,
          name: '',
          remark: ''
        };
        this.showAddAuxiliaryModal = true;
      });
    },
    /**
     * 根据类别名称获取前缀
     * @param {string} categoryName - 类别名称
     * @returns {string} 前缀
     */
    getCategoryPrefix(categoryName) {
      if (categoryName === '部门') {
        return 'BM';
      } else if (categoryName === '往来') {
        return 'WL';
      } else {
        // 其他类别使用首字母作为前缀
        return categoryName ? categoryName.substring(0, 1).toUpperCase() : 'A';
      }
    },

    /**
     * 生成下一个编码
     * @param {string} prefix - 编码前缀
     */
    async generateNextCode(prefix) {
      try {
        // 获取当前类别下的所有辅助核算数据
        // 使用正确的API调用方式，传入当前类别的ID和分页参数
        const response = await this.$api.setting.accountingCategoryDetails.list(
            this.currentAuxiliaryCategory.id,
            { page: 1, size: 9999 }
        );
        const data = response.data.records;

        if (!data || data.length === 0) {
          // 如果没有数据，从 00001 开始（5位数字）
          return prefix + '01001';
        }

        // 提取所有以指定前缀开头的编码并过滤出符合格式的编码（支持4位或更多位数字）
        const codes = data
            .map(item => item.code)
            .filter(code => code && new RegExp(`^${prefix}\\d{4,}$`).test(code));

        if (codes.length === 0) {
          // 如果没有符合格式的编码，从 00001 开始（5位数字）
          return prefix + '01001';
        }

        // 获取最大编码并加1
        const maxCode = codes.reduce((max, code) => {
          const num = parseInt(code.substring(prefix.length));
          const maxNum = parseInt(max.substring(prefix.length));
          return num > maxNum ? code : max;
        }, prefix + '00000');

        const nextNum = parseInt(maxCode.substring(prefix.length)) + 1;
        // 保持与原编码相同的数字部分长度
        const numLength = maxCode.substring(prefix.length).length;
        return prefix + nextNum.toString().padStart(numLength, '0');
      } catch (error) {
        console.error('生成编码失败:', error);
        // 出错时返回默认编码
        return prefix + new Date().getTime().toString().slice(-5);
      }
    },

    /**
     * 添加新的辅助核算项目
     */
    async addAuxiliaryItem() {
      if (!this.newAuxiliaryForm.code || !this.newAuxiliaryForm.name) {
        this.$Message('编码和名称不能为空');
        return;
      }

      try {
        // 构造要提交的数据，使用正确的参数格式
        const formData = Object.assign({
          accountingCategoryId: this.currentAuxiliaryCategory.id
        }, this.newAuxiliaryForm);

        // 调用API保存新的辅助核算项目
        const response = await this.$api.setting.accountingCategoryDetails.save(formData);

        if (response.code === 200) {
          this.$Message.success('新增成功');

          // 关闭模态框
          this.showAddAuxiliaryModal = false;

          // 重新加载辅助核算数据
          if (this.currentAuxiliaryIndex >= 0 && this.details[this.currentAuxiliaryIndex].data.subjectId) {
            // 重新加载辅助核算数据，传入正确的参数
            this.loadAuxiliaryAccountingData(this.currentAuxiliaryIndex, this.details[this.currentAuxiliaryIndex].data.subject);
          } else {
            // 如果没有有效的索引或科目，重新加载当前编辑的科目数据
            if (this.currentEdit && this.currentEdit.row && this.currentEdit.row.data && this.currentEdit.row.data.subject) {
              this.loadAuxiliaryAccountingData(this.currentEdit.idx, this.currentEdit.row.data.subject);
            }
          }

          // 清空表单
          this.newAuxiliaryForm = {
            code: '',
            name: '',
            remark: ''
          };
        } else {
          this.$Message.error(response.message || '新增失败');
        }
      } catch (error) {
        console.error('新增辅助核算项目失败:', error);
        this.$Message.error('新增辅助核算项目失败');
      }
    },
    kmInput(e) {
      this.kmFiler = e.target.value;
      this.$set(this.details[this.currentEdit.idx], 'auxiliary', false);
    },
    zyInput(e) {
      this.zyFiler = e.target.value;
      this.$set(this.details[this.currentEdit.idx].data, 'summary', e.target.value);
    },
    removeItem() {
      if (this.details.length > 4) {
        this.details.splice(this.hoverIdx, 1);
      } else {
        this.$set(this.details[this.hoverIdx], 'data', {});
      }
    },
    addItem(idx) {
      this.details.splice(idx ? idx : Math.max((this.hoverIdx), 0), 0, {
        zyEdit: false,
        kmEdit: false,
        jfEdit: false,
        dfEdit: false,
        auxiliary: false,
        data: {summary: '', subjectName: ''}
      });
      this.$nextTick(() => {
        this.bindEnterTabKeydownEvt();
      })
    },
    doEdit(row, type, idx,currentIndex) {
      if (this.currentEdit) {
        this.endEdit(this.currentEdit.row, this.currentEdit.type, this.currentEdit.idx)
      }
      // 复制上一行摘要内容
      if (type === 'zy' && currentIndex > 0) {
        const prevRow = this.details[currentIndex - 1];
        this.$set(row.data, 'summary', prevRow.data.summary);
      }

      this.$nextTick(() => {
        this.$set(row, type + 'Edit', true);
        this.currentEdit = {row, type, idx};

        this.$nextTick(() => {
          let keMuTxt = jQuery(`textarea#${type}${idx}`);
          keMuTxt.focus().select();
          if (type === 'km') {
            keMuTxt.val(row.data.subjectName);
            if (row.data.subject && row.data.subject.auxiliaryAccounting) {
              this.$set(this.details[idx], 'auxiliary', true);

            }
          } else if (type === 'zy') {
            //在 type 为 'zy' 时，将复制后的摘要内容赋值给文本区域
            keMuTxt.val(row.data.summary);
          }
          jQuery(".h-input", `#${type}${idx}`).focus().select();
          jQuery(`#${type}${idx}`).focus().select();
          this.$refs[`${type}Dropdown`][idx].show();
        });
      });
    },
    endEdit(row, type, idx, doNext = false) {
      if (row[type + 'Edit']) {
        this.$set(row, type + 'Edit', false);
        this.kmFiler = "";
        let debitAmount = Number(row.data.debitAmount);
        let creditAmount = Number(row.data.creditAmount);
        switch (type) {
          case 'jf':
            if (!isNaN(debitAmount) && !isNaN(creditAmount) && debitAmount) {
              this.$set(row.data, 'creditAmount', '');
            }
            this.calculateBalance(row.data.subjectId);
            break;
          case 'df':
            if (!isNaN(debitAmount) && !isNaN(creditAmount) && creditAmount) {
              this.$set(row.data, 'debitAmount', '');
            }
            break;
        }

        this.calculateBalance(row.data.subjectId);

        //如果有单位则需要计算单价
        if (row.data.unit && row.data.num > 0) {
          let money = debitAmount || creditAmount;
          this.$set(this.details[idx].data, 'price', Number((money / row.data.num).toFixed(2)));
        }

        let dropdown = this.$refs[`${type}Dropdown`][idx];
        dropdown && dropdown.hide();
        //关闭辅助项输入
        this.$set(this.details[idx], 'auxiliary', false);

        if (doNext) {
          if (type === 'jf' && row.data.debitAmount) {
            this.lastNext(idx);
          } else if (type !== 'df') {
            this.doEdit(row, nextTag[type], idx);
          } else {
            this.lastNext(idx);
          }
        }
      }
    },
    lastNext(idx) {
      let row = this.details[idx + 1];
      if (!row) {
        this.addItem(idx + 1);
      }
      this.doEdit(this.details[idx + 1], 'zy', idx + 1, idx + 1);
    },
    calculateBalance(subjectId) {
      if (subjectId) {
        let balance = this.initBalanceList[subjectId] || 0;
        let items = this.voucherItems.filter(val => val.subjectId === subjectId);
        items.forEach(val => {
          if (val.direction === "借") {
            if (val.debitAmount) {
              balance += Number(val.debitAmount);
            } else if (val.creditAmount) {
              balance -= Number(val.creditAmount);
            }
          } else {
            if (val.debitAmount) {
              balance -= Number(val.debitAmount);
            } else if (val.creditAmount) {
              balance += Number(val.creditAmount);
            }
          }
        });
        this.$set(this.balanceList, subjectId, FormatNum(balance));
      }
    },
    /**
     * 加载凭证科目数据和摘要数据
     * 优先从 localStorage 中获取数据，如果没有则通过 API 请求获取，并将获取的数据存储到 localStorage 中
     */
    loadVoucherSelect() {
      // 从 localStorage 中获取凭证选择数据
      let tmp = localStorage.getItem('voucherSelect');
      // 从 localStorage 中获取摘要数据
      let tmp2 = localStorage.getItem('summarySelect');
      // 若 localStorage 中存在凭证选择数据
      if (tmp) {
        // 将获取的 JSON 字符串解析为对象，并赋值给组件的 voucherSelect 属性
        this.voucherSelect = JSON.parse(tmp);
      }
      // 若 localStorage 中存在摘要数据
      if (tmp2) {
        // 将获取的 JSON 字符串解析为对象，并赋值给组件的 summarySelect 属性
        this.summarySelect = JSON.parse(tmp2);
      }

      // 调用 API 请求获取凭证选择数据
      this.$api.setting.subject.voucherSelect().then(({data}) => {
        // 将 API 返回的凭证选择数据赋值给组件的 voucherSelect 属性
        this.voucherSelect = data;
        // 将凭证选择数据以 JSON 字符串形式存储到 localStorage 中
        localStorage.setItem("voucherSelect", JSON.stringify(data));
      });

      // 调用 API 请求获取摘要数据
      this.$api.voucher.summary().then(({data}) => {
        // 对 API 返回的摘要数据进行处理，为每个摘要生成对应的助记码
        let newData = data.map(val => {
          return {
            name: val, // 摘要名称
            mnemonicCode: ToPy(val) // 摘要助记码
          }
        });
        // 将处理后的摘要数据赋值给组件的 summarySelect 属性
        this.summarySelect = newData;
        // 将处理后的摘要数据以 JSON 字符串形式存储到 localStorage 中
        localStorage.setItem("summarySelect", JSON.stringify(newData));
      });
    },

    /**
     * 选择摘要并更新对应行的数据
     * @param {Object} d - 当前行的数据对象
     * @param {string} summary - 选中的摘要内容
     * @param {number} idx - 当前行的索引
     */
    chooseSummary(d, summary, idx) {
      // 使用 $set 方法响应式地更新当前行数据对象中的摘要内容
      this.$set(d.data, 'summary', summary);
      // 使用 jQuery 选择对应的 textarea 元素，并将其值设置为当前编辑行数据中的摘要内容
      jQuery(`textarea#zy${idx}`).val(this.currentEdit.row.data.summary);
      // 隐藏当前行对应的摘要下拉框组件
      this.$refs.zyDropdown[idx].hide();
    },
    /**
     * 选择会计科目并更新对应行的数据
     * @param {Object} d - 当前行的数据对象
     * @param {Object} subject - 选中的会计科目对象
     * @param {number} idx - 当前行的索引
     */
    chooseSubject(d, subject, idx) {
      if (d.data.subjectId !== subject.id) {
        this.$set(d, 'data', {
          'subjectName': subject.code + "-" + subject.name,
          'subjectId': subject.id,
          'subjectCode': subject.code,
          'unit': subject.unit,
          'direction': subject.balanceDirection,
          'summary': d.data.summary,
          'creditAmount': d.data.creditAmount,
          'debitAmount': d.data.debitAmount,
          'subject': subject
        });
        this.loadSubjectBalance(d.data, subject.id);
      }
      //判断是否有辅助项目
      if (subject.auxiliaryAccounting) {
        this.auxiliaryAccounting[idx] = JSON.parse(subject.auxiliaryAccounting);
        this.loadAuxiliaryAccountingData(idx, subject);
        //开启辅助项输入
        this.$nextTick(() => {
          this.$set(this.details[idx], 'auxiliary', true);
          this.$set(this.currentEdit, 'auxiliary', true);
          // 自动打开辅助核算模态框，提高输入效率
          setTimeout(() => {
            this.openAuxiliaryModal(idx, d);
          }, 100);
        });
        jQuery(`textarea#km${idx}`).val(this.currentEdit.row.data.subjectName);
      } else {
        this.endEdit(d, 'km', idx, true);
      }
    },
    /**
     * 加载指定会计科目的余额信息
     * @param {Object} d - 当前行的数据对象，用于存储余额信息
     * @param {string|number} subjectId - 会计科目的 ID
     */
    loadSubjectBalance(d, subjectId) {
      // 检查 balanceList 对象中是否已存在该会计科目的余额信息
      if (!this.balanceList[subjectId]) {
        // 若不存在，则调用 API 请求该会计科目的余额信息
        this.$api.setting.subject.balance({subjectId: subjectId}).then(({data}) => {
          // 将 API 返回的余额信息存储到 balanceList 对象中
          this.balanceList[subjectId] = data;
          // 将初始余额信息存储到 initBalanceList 对象中
          this.initBalanceList[subjectId] = data;
          // 使用 $set 方法响应式地将余额信息添加到当前行的数据对象中
          this.$set(d, 'balance', data);
        })
      } else {
        // 若已存在余额信息，则直接将其赋值给当前行的数据对象
        this.$set(d, 'balance', this.balanceList[subjectId]);
      }
    },

    clear() {
      this.details = initDetails();
    },
    /**
     * 加载辅助核算数据
     * @param {number} idx - 当前行的索引
     * @param {Object} subject - 当前选择的会计科目对象
     */
    loadAuxiliaryAccountingData(idx, subject) {

      /**
       * 调用 API 加载辅助核算项目数据
       * 传入当前行的辅助核算类别配置，获取对应的辅助核算项目明细
       */

       this.$api.setting.accountingCategoryDetails.loadAuxiliaryAccountingData(this.auxiliaryAccounting[idx]).then(({data}) => {
        // 处理数据，添加 codeAndName 字段
         /**
          * 初始化处理后的数据结构对象
          * 用于存储按类别分组的辅助核算项目数据
          */
        const processedData = {};
         /**
          * 遍历 API 返回的数据对象
          * 每个 key 代表一个辅助核算类别 ID
          * 对应该类别下的所有辅助核算项目数组
          */
        Object.keys(data).forEach(key => {
          /**
           * 为每个辅助核算项目添加 codeAndName 组合字段
           * 格式为"编码 - 名称"，便于在下拉框中显示
           */
          processedData[key] = data[key].map(item => ({
            ...item,
            codeAndName: `${item.code}-${item.name}`
          }));
        });
         /**
          * 使用 Vue 的响应式方法将处理后的数据存储到组件中
          * 以会计科目 ID 作为键名，便于后续根据科目快速查找
          */
        this.$set(this.auxiliaryAccountingData, subject.id, processedData);
         // console.log("auxiliaryAccountingData JSON格式:", JSON.stringify(this.auxiliaryAccountingData, null, 2));
      }).catch(error => {
        console.error('加载辅助核算数据失败:', error);
      });
    },
    /**
     * 填充辅助核算信息
     * @param {Object} row - 行数据对象
     * @param {Object} auxiliaryData - 辅助核算数据
     * @param {Number} idx - 行索引
     */
    fillAuxiliary(row, auxiliaryData, idx) {
      let title = "", rowData = row.data;
      // 遍历辅助核算数据，拼接标题字符串
      Object.keys(auxiliaryData).forEach(val => {
        if (rowData[val]) {
          title += '_' + rowData[val].code + "_" + rowData[val].name;
        }
      });
      // 结束编辑状态并更新辅助核算标题
      this.endEdit(row, 'km', idx, true);
      this.$nextTick(() => {
        this.$set(rowData, "auxiliaryTitle", title);
      });
    },
    showInput(e) {
      let target = jQuery(e.target);
      target.hide();
      target.next().show().focus().select();
    },
    hideInput(e, row) {
      let target = jQuery(e.target);
      target.hide();
      target.prev().show();
      let inputs = target.closest('.num').find('.numInput');
      switch (row.direction) {
        case '借':
          this.$set(row, "debitAmount", FormatNum(Number(inputs[0].value) * Number(inputs[1].value)));
          this.$set(row, "creditAmount", "");
          break;
        case '贷':
          this.$set(row, "creditAmount", FormatNum(Number(inputs[0].value) * Number(inputs[1].value)));
          this.$set(row, "debitAmount", "");
          break;
      }
    },
    /**
     * 初始化凭证表格的数据
     * @param {Array} voucherItems - 包含凭证条目数据的数组
     */
    initValue(voucherItems) {
      // 重置 details 数组，初始化为包含 4 个空条目的数组
      this.details = [{zyEdit: false, kmEdit: false, jfEdit: false, dfEdit: false, auxiliary: false, data: {summary: ''}}, {zyEdit: false, kmEdit: false, jfEdit: false, dfEdit: false, auxiliary: false, data: {summary: ''}}, {zyEdit: false, kmEdit: false, jfEdit: false, dfEdit: false, auxiliary: false, data: {summary: ''}}, {zyEdit: false, kmEdit: false, jfEdit: false, dfEdit: false, auxiliary: false, data: {summary: ''}}];
      // 遍历传入的凭证条目数组
      voucherItems.forEach((item, idx) => {
        // 以下两行代码存在变量自我赋值问题，可移除
        item.subjectName = item.subjectName;
        item.auxiliaryTitle = item.auxiliaryTitle;
        // 若凭证条目包含会计科目信息
        if (item.subject) {
          // 设置凭证条目的余额方向为会计科目的余额方向
          item.direction = item.subject.balanceDirection;
          // 设置凭证条目的单位为会计科目的单位
          item.unit = item.subject.unit;
          // 若会计科目存在辅助核算配置
          if (item.subject.auxiliaryAccounting) {
            // 解析辅助核算配置并存储到当前索引对应的辅助核算配置数组中
            this.auxiliaryAccounting[idx] = JSON.parse(item.subject.auxiliaryAccounting);
            // 加载当前索引对应的会计科目的辅助核算数据
            this.loadAuxiliaryAccountingData(idx, item.subject);
          }
        }
        // 若凭证条目包含辅助核算信息
        if (item.auxiliary) {
          // 遍历辅助核算信息数组
          item.auxiliary.forEach(a => {
            // 将辅助核算明细信息赋值到凭证条目对象中
            item[a.accountingCategoryId] = a.accountingCategoryDetails;
          });
          // 删除凭证条目中的 auxiliary 属性
          delete item.auxiliary;
        }
        // 使用 $set 方法响应式地更新 details 数组中对应索引的元素
        // 将 detail 对象和包含凭证条目数据的对象合并后赋值给 details 数组的对应位置
        this.$set(this.details, idx, Object.assign({}, detail, {data: item}));
      });
    },
    // 绑定回车和Tab键事件
    bindEnterTabKeydownEvt() {
      let that = this;
      jQuery(".trDetails").off("keyup", ".edit");
      jQuery(".trDetails").off("keydown", ".edit");
      jQuery(".trDetails").off("blur", ".jf,.df");

      jQuery(".trDetails").on("blur", ".jf,.df", (e) => {
        let {type, index} = jQuery(e.target).closest('.edit').data();
        this.endEdit(that.details[index], type, index, false);
      });

      jQuery(".trDetails").on("keyup", ".edit", function (e) {
        let {type, index} = jQuery(e.target).closest('.edit').data();
        //贷方等于号输入处理
        if ((e.keyCode === 187 || e.code === "Equal" || e.code === "NumpadEqual" || e.key === "=") && (type === 'jf' || type === 'df')) {
          e.preventDefault();
          let details = Array.from(that.details);
          let totalCredit = 0, totalDebit = 0;
          details.forEach((value, i) => {
            if (index !== i) {
              let creditAmount = Number(value.data.creditAmount), debitAmount = Number(value.data.debitAmount);
              if (!isNaN(creditAmount)) {
                totalCredit += creditAmount;
              }
              if (!isNaN(debitAmount)) {
                totalDebit += debitAmount;
              }
            }
          });

          if (type === 'jf' && totalCredit !== 0) {
            details[index].data.debitAmount = FormatNum(totalCredit - totalDebit);
            details[index].data.creditAmount = 0;
            e.target.value = details[index].data.debitAmount;
          } else if (type === 'df' && totalDebit !== 0) {
            details[index].data.creditAmount = FormatNum(totalDebit - totalCredit);
            details[index].data.debitAmount = 0;
            e.target.value = details[index].data.creditAmount;
          }

          that.$set(that, 'details', details);
          return false;
        }
      });

      jQuery(".trDetails").on("keydown", ".edit", function (e) {
        let {type, index} = jQuery(e.target).closest('.edit').data();
        // 处理回车键和Tab键
        if (e.keyCode === 13 || e.keyCode === 9) {
          e.preventDefault();
          if (type === 'km') {
            jQuery('li.subjects-item-select', `#subjects${index}`).click();
            return;
          }
          if (type === 'zy') {
            let select = jQuery(`.summary-item-select`, `#summary${index}`);
            if (select.length) {
              that.$set(that.details[index].data, 'summary', select.text());
            }
          }
          that.endEdit(that.details[index], type, index, true);
          return false;
        }

        // 处理方向键（上下左右键）

        if (e.keyCode >= 37 && e.keyCode <= 40) {
          e.preventDefault();

          // 左右键处理 - 在不同单元格之间移动
          if (e.keyCode === 37 || e.keyCode === 39) {
            let nextType = type;
            // 左键 (37) - 向前移动
            if (e.keyCode === 37) {
              if (type === 'df') nextType = 'jf';
              else if (type === 'jf') nextType = 'km';
              else if (type === 'km') nextType = 'zy';
            }
            // 右键 (39) - 向后移动
            else if (e.keyCode === 39) {
              if (type === 'zy') nextType = 'km';
              else if (type === 'km') nextType = 'jf';
              else if (type === 'jf') nextType = 'df';
            }

            // 如果类型发生变化，则结束当前编辑并开始下一个编辑
            if (nextType !== type) {
              that.endEdit(that.details[index], type, index, false);
              that.$nextTick(() => {
                // 当移动到摘要字段且不是第一行时，自动复制第一行摘要
                if (nextType === 'zy' && index > 0 && that.details[0] && that.details[0].data.summary) {
                  that.$nextTick(() => {
                    that.doEdit(that.details[index], nextType, index);
                    // 设置当前行摘要为第一行摘要
                    that.$set(that.details[index].data, 'summary', that.details[0].data.summary);
                    // 更新textarea的值
                    jQuery(`textarea#${nextType}${index}`).val(that.details[0].data.summary);
                  });
                } else {
                  that.doEdit(that.details[index], nextType, index);
                }
              });
            }
            return false;
          }
          // 上下键处理
          // 上键到上一行相同字段
          if (e.keyCode === 38) {
            e.preventDefault();
            if (index > 0) {
              that.endEdit(that.details[index], type, index, false);
              that.$nextTick(() => {
                // 当移动到摘要字段且不是第一行时，自动复制第一行摘要
                if (type === 'zy' && (index - 1) > 0 && that.details[0] && that.details[0].data.summary) {
                  that.doEdit(that.details[index - 1], type, index - 1);
                  // 设置当前行摘要为第一行摘要
                  that.$set(that.details[index - 1].data, 'summary', that.details[0].data.summary);
                  // 更新textarea的值
                  jQuery(`textarea#${type}${index - 1}`).val(that.details[0].data.summary);
                } else {
                  that.doEdit(that.details[index - 1], type, index - 1);
                }
              });
            }
            return false;
          }
          // 下键到下一行相同字段
          if (e.keyCode === 40) {
            e.preventDefault();
            that.endEdit(that.details[index], type, index, false);
            that.$nextTick(() => {
              // 如果是最后一行，添加新行
              if (index === that.details.length - 1) {
                that.addItem(that.details.length);
              }
              // 当移动到摘要字段且不是第一行时，自动复制第一行摘要
              if (type === 'zy' && (index + 1) > 0 && that.details[0] && that.details[0].data.summary) {
                that.doEdit(that.details[index + 1], type, index + 1);
                // 设置当前行摘要为第一行摘要
                that.$set(that.details[index + 1].data, 'summary', that.details[0].data.summary);
                // 更新textarea的值
                jQuery(`textarea#${type}${index + 1}`).val(that.details[0].data.summary);
              } else {
                that.doEdit(that.details[index + 1], type, index + 1);
              }
            });
            return false;
          }
          // 上下键在科目和摘要列表中选择（仅当在科目或摘要编辑状态时）
          if ((type === 'km' || type === 'zy') && (e.keyCode === 38 || e.keyCode === 40)) {
            let idPre = type === 'km' ? "subjects" : "summary";
            let subjects = jQuery(`#${idPre}${index}`);
            let select = jQuery(`.${idPre}-item-select`, subjects);

            // 如果没有选中项，则选中第一项
            if (!select.length) {
              subjects.children().first().addClass(`${idPre}-item-select`);
              return false;
            }

            // 根据按键确定下一个选中项
            let next = select.prev('li'); // 上键选择前一项
            if (e.keyCode === 40) {
              next = select.next('li'); // 下键选择后一项
            }

            // 如果存在下一个选项，则更新选中状态
            if (next.length) {
              next.addClass(`${idPre}-item-select`);
              select.removeClass(`${idPre}-item-select`);

              // 如果选项索引大于7，需要滚动列表
              let i = next.data('index');
              if (i > 7) {
                let top = subjects.parent().scrollTop();
                subjects.parent().scrollTop(top + 22)
              }
            }
            return false;
          }
        }



      });
    },
    calculationOfTotal() {
      let jfTotal = 0, dfTotal = 0;
      this.details.forEach(value => {
        let debit, credit;
        if ((debit = Number(value.data.debitAmount))) {
          jfTotal += debit;
        }
        if ((credit = Number(value.data.creditAmount))) {
          dfTotal += credit;
        }
      });

      this.jfTotal = FormatNum(jfTotal);
      this.dfTotal = FormatNum(dfTotal);
    }
  },
  filters: {
    formatMoney: function (value) {
      if (Number(value)) {
        let sp = (Math.abs(FormatNum(value)) + "").split(".");
        if (!sp[1]) {
          return sp[0] + "00"
        } else if (sp[1].length < 2) {
          return sp[0] + sp[1] + "0"
        }
        return sp[0] + sp[1];
      }
      return '';
    },
    fixNum(value) {
      return Number(value) ? FormatNum(value) : '';
    }
  },
  watch: {
    details: {
      deep: true,
      handler() {
        this.calculationOfTotal();
        this.$emit("input", {
          voucherItems: this.voucherItems,
          jfTotal: this.jfTotal || null,
          dfTotal: this.dfTotal || null
        });
      }
    }

  },
  mounted() {
    // 保存当前组件实例的引用，避免在回调函数中 this 指向问题
    let that = this;
    // 等待 DOM 更新完成后执行回调
    this.$nextTick(() => {
      // 为表格的行添加鼠标移入事件监听
      jQuery('table.body').on("mouseover", 'tr.trDetails:not(.total)', function () {
        // 获取当前鼠标悬停行的索引
        that.hoverIdx = jQuery(this).data('idx');
        // 获取当前行相对于文档的偏移量
        let offset = jQuery(this).offset();
        // 获取当前行的父元素相对于文档的偏移量
        let offsetParent = jQuery(this).offsetParent().offset();

        // 设置添加按钮的位置并显示
        jQuery('i.fa-plus-circle').css({
          left: offset.left - offsetParent.left - 14,
          top: offset.top - offsetParent.top + 25,
          display: 'inline-block'
        }).show();
        // 设置删除按钮的位置并显示
        jQuery('i.fa-times-circle').css({
          left: offset.left - offsetParent.left + 960,
          top: offset.top - offsetParent.top + 25,
          display: 'inline-block'
        }).show();
        // 为表格的行添加鼠标移出事件监听
      }).on("mouseleave", 'tr.trDetails', function () {
        // 隐藏未被悬停的操作按钮
        jQuery("i.action[class!='show']").hide();
      });

      // 为操作按钮添加鼠标悬停事件监听
      jQuery('i.action').hover(function () {
        // 鼠标移入时添加 'show' 类并显示按钮
        jQuery(this).addClass('show').css({display: 'inline-block'});
      }, function () {
        // 鼠标移出时移除 'show' 类并隐藏按钮
        jQuery(this).removeClass('show').hide();
      });

      // 为 #app 元素添加点击事件监听
      jQuery("#app").click((e) => {
        // 当点击的元素不是特定元素且当前有正在编辑的内容时
        if (!jQuery(e.target).hasClass('display')
            && !jQuery(e.target).hasClass('subjects-item')
            && !jQuery(e.target).closest('.auxiliary').length
            && !jQuery(e.target).closest('.tdInput').length
            && !jQuery(e.target).closest('.h-dropdown').length
            && this.currentEdit) {
          // 结束当前编辑状态
          this.endEdit(this.currentEdit.row, this.currentEdit.type, this.currentEdit.idx)
        }
      });

      // 绑定回车键和 Tab 键的键盘事件
      this.bindEnterTabKeydownEvt();
    });

    // 加载凭证选择数据和摘要数据
    this.loadVoucherSelect();
  }

}
</script>

<style lang="less">
.voucher-table {
  position: relative;
  font-size: 12px;
  width: 1000px;
  padding: 10px 20px;

  .tdLast {
    border-right: 1px solid #dadada;
  }

  .header {
    width: 960px;
    text-align: center;
    line-height: 30px;
  }

  table tbody tr td {
    border-left: 1px solid #dadada;
    border-top: 1px solid #dadada;
    border-bottom: 1px solid #dadada;
    padding: 0;
    border-spacing: 0;
  }

  .moneyUint {
    border-top: 1px solid #dadada;
    height: 30px;
    background-image: url(../assets/moneyUint.png);
    width: 221px;

    span {
      float: left;
      display: inline;
      width: 19px;
      height: 100%;
      margin-right: 1px;
      background-color: #fff;
      text-align: center;
      font-size: 12px;
    }

    .last {
      margin-right: 0;
    }
  }

  .body {
    width: 960px;
    text-align: center;

    .numInput {
      outline: none;
    }

    td {
      vertical-align: top;
    }

    .trDetails {
      width: 959px;

      .spTotal {
        width: 250px;
        text-align: left;
        vertical-align: middle;
        font-weight: bold;
      }

      .h-icon-error {
        right: 55px;
        top: 20px;
      }

      .display {
        height: 60px;
        font-weight: bold;
        font-size: 13px;
        text-align: left;
        padding: 2px;
        line-height: 17px;
      }

      .tdZhaoyao {
        width: 207px;
      }

      .tdKemu {
        width: 307px;
        position: relative;

        .yue {
          position: absolute;
          bottom: 2px;
          left: 2px;
          z-index: 2;
          font-weight: bold;
        }

        .num {
          position: absolute;
          bottom: 17px;
          right: 5px;
          line-height: 23px;
          font-weight: normal;
          z-index: 2;
        }
      }

      .tdJieFang, .tdDaiFang {
        width: 221px;
      }

      .displayMoney {
        font-weight: bold;
        font-size: 14px;
        letter-spacing: 11px;
        overflow: hidden;
        text-align: right;
        font-family: 'tahoma', serif;
        background-image: url(../assets/moneyUint.png);
        line-height: 60px;
        padding: 0;

        span {
          position: relative;
          right: -5px;
        }
      }

      .h-autocomplete-show {
        border: none;
        border-radius: 0;
      }

      .h-input {
        border: none;
        border-radius: 0;
        height: 60px !important;
        resize: none !important;
        width: 100% !important;
      }

      textarea.h-input {
        height: 60px !important;
      }

      .h-dropdowncustom-show-content {
        width: 100% !important;
      }
    }

    tbody:first-child td {
      border-top: 0 !important;
    }
  }

  .action {
    position: absolute;
    font-size: 16px;
    cursor: pointer;
    display: none;

    &:hover {
      color: @primary-color;
    }
  }

  .h-numberinput-show {
    border-radius: 0;

    &.focusing {
      border: 1px solid #44b449;
      box-shadow: none;
    }

    .h-input {
      font-size: 16px;
      font-weight: bold;
    }
  }
}

.subjects, .summary {
  li {
    padding: 2px 10px;
    cursor: pointer;
    font-size: 12px;
    white-space: nowrap;

    &:hover {
      background: @primary-color;
      color: @white-color;
    }
  }

  &-item-select {
    background: @primary-color;
    color: @white-color;
  }
}

.hoverNum {
  text-align: right;
  padding: 0 10px;
  font-size: 26px;
  font-weight: bold;
  height: 60px;
  line-height: 60px;
}
.auxiliary .subjects {
  li {
    padding: 2px 10px;
    cursor: pointer;
    font-size: 12px;
    white-space: nowrap;

    &:hover {
      background: @primary-color;
      color: @white-color;
    }
  }

  &-item-select {
    background: @primary-color;
    color: @white-color;
  }
}
.auxiliary-input {
  width: 100% !important;
  min-width: 440px !important;
}
// 全局修改Select组件悬停背景色（放在样式表最后）
//.h-select-item:hover {
//  background-color: #1890ff !important;
//  color: white !important;
//}
//
//.h-select-item-selected {
//  background-color: #1890ff !important;
//  color: white !important;
//}
// 修改 Select 组件各种状态下的背景色为蓝色
// 更具体的选择器来确保样式优先级

</style>